import { Textfield } from '../../primitives';
import { styled } from '../../theme';

export const EmailTextfield = styled(Textfield).attrs(() => ({
	type: 'email',
	placeholder: 'namn@exempel.com',
}))`
	width: 100%;
`;
